import { Title, Grid, Text, Stack } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import {
  IconBrandHtml5,
  IconBrandCss3,
  IconBrandJavascript,
  IconBrandBootstrap,
  IconBrandReact,
  IconBrandMantine,
  IconBrandVue,
  IconBrandPython,
  IconSettings,
  IconPencil,
  IconBrandFigma,
  IconBrandGithub,
  IconPhoto,
  IconBrandMysql,
  IconBrandBlender,
  IconCoffee,
  IconBrandNextjs,
  IconBrandReactNative,
  IconBrandMongodb,
} from "@tabler/icons";
import Skill from "../components/Skill";

function About() {
  const { height, width } = useViewportSize();

  return (
    <Grid ta="left" grow>
      <Grid.Col span={12}>
        <Title order={1} variant="gradient" size={50}>
          About Me
        </Title>
      </Grid.Col>

      <Grid.Col span={12}>
        <Title order={3} fw={500} py="xs">
          Summary
        </Title>
        <Text>
          Hello! My name is Raphael{" "}
          {/* <Text span c="dimmed">
            (Yes, same as the Ninja Turtle).{" "}
          </Text> */}
          I'm currently a student pursuing my degree in Information Systems in
          Singapore Management University. My personal interests are mainly{" "}
          <Text span c="blue">
            working out and building cool stuff.{" "}
          </Text>
          {/* An overarching goal in my life is to{" "}

          <Text span c="blue">
            live life to the fullest without regrets.{" "}
          </Text> */}
          I have always been fasinated with blending great functionality &
          design, which is what led me to pursue web development.
        </Text>
      </Grid.Col>

      <Grid.Col md={12}>
        <Title order={3} fw={500} pt="xs">
          Proficiencies
        </Title>
      </Grid.Col>

      <Grid.Col xs={6} sm={6} md={3}>
        <Text fw={300} fz={20} pb="md">
          Languages
        </Text>
        <Stack justify="flex-start">
          <Skill name="Python" icon={<IconBrandPython />} />
          <Skill name="Java" icon={<IconCoffee />} />
          <Skill name="Javascript" icon={<IconBrandJavascript />} />
          <Skill name="HTML" icon={<IconBrandHtml5 />} />
          <Skill name="CSS" icon={<IconBrandCss3 />} />
        </Stack>
      </Grid.Col>

      <Grid.Col xs={6} sm={6} md={3}>
        <Text fw={300} fz={20} pb="md">
          Technologies
        </Text>
        <Stack>
          <Skill name="React" icon={<IconBrandReact />} />
          <Skill name="Nextjs" icon={<IconBrandNextjs />} />
          <Skill name="React Native" icon={<IconBrandReactNative />} />
          <Skill name="Vue" icon={<IconBrandVue />} />
          <Skill name="MongoDB" icon={<IconBrandMongodb />} />
          <Skill name="MySQL" icon={<IconBrandMysql />} />
        </Stack>
      </Grid.Col>

      {/* <Grid.Col xs={6} sm={6} md={3}>
        <Text fw={300} fz={20} pb="md">
          Other Languages
        </Text>
        <Stack>

        </Stack>
      </Grid.Col> */}

      <Grid.Col xs={6} sm={6} md={3}>
        <Text fw={300} fz={20} pb="md">
          Others
        </Text>
        <Stack>
          <Skill name="Illustrator" icon={<IconPencil />} />
          <Skill name="Photoshop" icon={<IconPhoto />} />
          <Skill name="Figma" icon={<IconBrandFigma />} />
          <Skill name="Github" icon={<IconBrandGithub />} />
          <Skill name="Blender" icon={<IconBrandBlender />} />
        </Stack>
      </Grid.Col>
    </Grid>
  );
}

export default About;
